/*========================================================================
* $Id: search.js 86378 2015-09-10 09:02:14Z michael.biebl $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/
define(
  [
    "client/templateregistry",
    "component!base",
    "component!row",
    "component!searchroot",
    "client/template",
    "client/templatetree",
    "client/layouttree",
    "api/v2/api",
    "i18n/i18n",
    "utils/clone",
    "utils/accessibility",
    "underscore",
    "jquery",
    "utils/dom",
    "utils/jsonpath",
    "!!raw-loader!../mustache/template.default.mustache",
    "!!raw-loader!../mustache/template.gallery.mustache",
    "!!raw-loader!../mustache/template.person.mustache",
    "backbone",
    "client/template-tree/simpleguard",
    "utils/clone"
  ],
  function (
    TemplateRegistry,
    Base,
    Row,
    SearchRootTemplate,
    Template,
    TemplateTree,
    LayoutTree,
    api,
    i18n,
    clone,
    Accessibility,
    _,
    $,
    dom,
    JSONPath,
    DEFAULT_TEMPLATE,
    GALLERY_TEMPLATE,
    PERSON_TEMPLATE,
    Backbone,
    SimpleGuard,
    deepClone
  ) {


    // Search template is special as it constructs a
    //  new TemplateTree based on the elements.
    // 
    // TODO: There should be a way for the Template
    //       to decide if it wants to skip children
    //       detection
    var SearchTemplate = Template.extend({

        editableName: "editor_searchcontainer",

        schema: new Template.Schema({
            attributes: {
              "template-preset": {
                type: "string",
                values:  ["default-results", "gallery-results", "person-results"],
                visible: false
              },
              "template-refid": {
                type: "string",
                visible: false
              },
              constraint: {
                path: "source_context.constraints.view_base",
                type: "QueryExpr",
                title: "editor_result_constraint"
              },
              count: {
                type: "int",
                title: "editor_result_count",
                values:  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
                defaultValue: 1 // TODO: not used
              },
              "inherit-constraints-from-parent": {
                type: "boolean",
                title: "editor_inherit_search_constraints_from_main_search",
                defaultValue: true,
                default: true
              },
              "parent-user-query-as-constraint": {
                type: "boolean",
                title: "editor_parent_user_query_as_constraint",
                defaultValue: false,
                default: false
              },
              "initialize-from-parent-user-query": {
                type: "boolean",
                title: "editor_initialize_from_parent_user_query",
                defaultValue: false,
                default: false,
                depends: "/^true$/i.test(attributes['parent-user-query-as-constraint'])"
              },
              "enabledViews": {
                type: "list",
                title: "editor_search_enabled_views",
                visible: false
              },
              "disabledViews": {
                type: "list",
                title: "editor_search_disabled_views",
                visible: false
              },
              "propagateToParent": {
                type: "boolean",
                defaultValue: false,
                "default": false,
                visible: false
              },
              "inheritInputPathFromParent": {
                type: "string",
                visible: false
              },
              "propagateInputPathToApplicationSearch": {
                type: "string",
                "default": "",
                visible: false
              },
              "model": {
                title: "editor_search_model",
                visible: false
              },
              "name": {
                title: "editor_search_name",
                "default": "default"
              },
              "hide-on-no-results": {
                type: "boolean",
                defaultValue: false,
                visible: false
              },
              "requires-user-input": {
                type: "boolean",
                defaultValue: false,
                visible: false
              },
              "compute-onchange": {
                type: "string",
                defaultValue: true,
                "default": "input",
                visible: false
              },
              "settings": {
                type: "string",
                title: "editor_search_settings",
                defaultValue: false,
              }
            }
        }),

        remove: function (options) {
          _.forEach(this.instances, function (view) {
            view.remove();
          });
          this.instances = [];
          var nodeChildren = options && options.node && options.node.children;
          _.forEach(nodeChildren, function (childNode) {
            childNode.template.remove({
              node: childNode
            });
          });
        },

        hasContent: function () {
          return false;
        },

        createView: function (options) {
          // data-requires-expr="settings"

          // in former createView was called two times. In this case we are
          //  calling it with SearchRootTemplate.
          if (!this.node.parentNode) {
            var options = _.extend({}, options, {ViewConstructor: SearchRootTemplate.View});
            return Template.prototype.createView.call(this, options);
          }
          
          var requiresExpr = this.attributeModel.get("requires-expr");
          var guard = null;
          if (requiresExpr) {
            guard = new SimpleGuard(options.application.exprEnvironment, requiresExpr);
          }
          
          var that = this;
          var outerOptions = _.extend({}, options);
          var getViewOptions = function() {
            var searchSettings = that.attributeModel.getCamelCase();
            var settingsPath = that.attributeModel.get("settings");
            if (settingsPath) {
              var settings = JSONPath.get(outerOptions.application.options.settings, settingsPath);
              if (settings) {
                searchSettings = _.extend({}, settings, searchSettings);
              }
            }
            
            var channelType = searchSettings.channelType;
            var channelURL = searchSettings.channelUrl;
            if (channelType) {
              var channel = outerOptions.application.channels.channelFactory.createChannel({channelType: channelType, url: channelURL});
            }
            
            var inputTransform = searchSettings.inputTransform,
                inputTransformFunction = inputTransform && new Function("input", "application", inputTransform);
            
            var inheritConstraintsFromParent = searchSettings.inheritConstraintsFromParent;
            inheritConstraintsFromParent = inheritConstraintsFromParent === "true";
            
            var resultOptions = _.extend(
              {},
              outerOptions,
              that.schema.parseAttributes(searchSettings),
              {
                modelId: searchSettings.model,
                inputTransform: inputTransformFunction,
                inheritConstraintsFromParent: inheritConstraintsFromParent,
                channel: channel
              }
            );
            return resultOptions;
          }
          var view = new this.constructor.View(_.extend({}, options,
            {
              guard: guard, getViewOptions: getViewOptions,
              parentUserQueryAsConstraint: that.get("parent-user-query-as-constraint"),
              initializeFromParentUserQuery: that.get("initialize-from-parent-user-query")
            }
          ));
          this.instances.push(view);
          return view;
        }

    });

    SearchTemplate.View = Base.extend({
      lateInitializeAlreadyCalled: false,

      initialize: function() {
        if (this.options.guard) {
          this.options.guard.setEnableAction(_.bind(this.handleGuardEnabled, this));
        }
        else {
          this.lateInitialize();
        }
      },

      remove: function () {
          if (this.options.guard) {
            this.options.guard.destroy();
          }
          var propagateToSearchTemplate = this.options.application.editing;
          this.cleanupView(propagateToSearchTemplate);

          Base.prototype.remove.apply(this, arguments);

          return this;
        },

        cleanupView: function(propagateToSearchTemplate) {
          if (this.templateTree) {
            this.templateTree.destroy();
          }
          
          if (propagateToSearchTemplate) {
            this.options.node.template.el.innerHTML = '';
            $(this.options.node.template.el).append($(this.el).children());
          }
          if (this.resultsModel) this.resultsModel.destroy();
          if (this.model) this.model.destroy();
          delete this.options.application.models[this.modelId];
        },

        getSnippet: function ($el) {
          // We don't want classes like 'mb-selected' and 'mb-computing' in the generated and export-ready snippet
          return $el.html().replace(/mb-selected|mb-computing/g, "");
        },


        handleGuardEnabled: function() {
          
          // cleanup if is lateInitialize is at least called once
          if (this.lateInitializeAlreadyCalled) {
            var propagateToSearchTemplate = false;
             this.cleanupView(propagateToSearchTemplate);
          }
          return this.lateInitialize();
        },
      
        lateInitialize: function () {
          this.lateInitializeAlreadyCalled = true;

          if (this.options.getViewOptions) {
            this.options = _.extend({}, this.options, this.options.getViewOptions());
          }
        
          var that = this,
              templateEl,
              templateString,
              templatedRefidUsed;

          this.channel = this.options.channel;

          this.createModel({channel: this.channel});
          if (this.options.requiresUserInput === true || this.options.requiresUserInput === 'true') {
            // TODO: use same logic as in searchform
            this.model.input.addValidator(function () {
                var unparsedUserQuery = that.model.input.get(that.options.application.getUnparsedUserQueryPath())
                return !!unparsedUserQuery;
            });
          }
          if (this.options.constraint && !_.isEmpty(this.options.constraint)) {
            this.model.set(
              "source_context.constraints.searchcontainer",
              this.options.constraint,
              {silent:true}
            );
          }

          this.model.set("count", this.options.count, {silent:true});
          this.setSearchName();

          if (this.options.propagateToParent) {
            this.listenTo(this.model.input, "change", this.updateParentIfUserQueryChanged);
          }

          if (this.options.propagateInputPathToApplicationSearch) {
            this.listenTo(this.model.input, "change", this.updateGlobalSearchIfNeeded);
          }
          
          if (this.options.hideOnNoResults) {
            this.resultsModel = this.model.submodel("resultset.results");
            this.listenTo(this.model, "change", this.updateDisplay);
            this.updateDisplay();
          }

          if (this.options.templateRefid) {
            templateEl = document.getElementById(this.options.templateRefid);
            templateString = templateEl && templateEl.innerHTML || "Could not find template with id \"" + this.options.templateRefid + "\"";
          
            templateString = this.replaceTemplateOptions(templateString);
            templatedRefidUsed = true;
          } else {
            templateString = this.options.node.el.innerHTML;
            this.options.node.el.style.display="none";
            templateString = this.replaceTemplateOptions(templateString);
          }

          if (this.options.templatePreset && !templatedRefidUsed) {
            templateString = this.replaceTemplateOptions(this.setTemplatePreset());
            if (this.options.alignment) {
              $(this.el).addClass(this.options.alignment);
            }
          }

          if (this.options.width) {
            var width;
            switch(this.options.width) {
              case "50":
                width = 50;
                break;
              case "100":
                width = 100;
                break;
              case "33":
                width = 33;
                break;
              case "66":
                width = 66;
                break;
              default:
                width = 100;
                break;
            };
            $(this.el).addClass("boxWidth" + width);
          }

          this.disable();
          
          var TreeConstructor = this.options.application.editing ? LayoutTree : TemplateTree;
          if (this.options.application.editing) {
            templateString = undefined;
            $(this.el).append(this.options.node.el.children);
          }

          // FIXME: this should be done on the Template level?

          // change to "searchroot" instead of search?
          this.templateTree = new TreeConstructor(this.el, "searchroot", templateString,
                                                  {application: this.options.application , node: this.options.node});

          if (this.options.showInTab) this.createBoxShadowWithArrow();
          this.templateTree.initialize(this.options.application, this.model, function (errors) {
            that.options.application.views.trigger("initalized:TemplateTree", that.options.application, that, that.model);

            try {
              if (that.options.enableAccessibilityHandlers) {
                that.accessibilityContainer = new Accessibility.Container(that.rootEls);
              }
              i18n.patchI18nAttributes();
              that.originalInput = clone(that.model.input.get());
              var computeOnchange = (that.options.computeOnchange || "input");
              if (computeOnchange == "input" || computeOnchange == "output") {
                if (that.options.application.models.search[computeOnchange]) {
                  that.listenTo(that.options.application.models.search[computeOnchange], "change", that.updateInput);
                }
              }
              that.updateInput();
            } catch (e) {
              console.warn("Failed! " , e.message);
            }
          });
        },

        createBoxShadowWithArrow: function() {
          var arrow = document.createElement('div');
          arrow.className = "tabArrow";

          if (this.options.showInTab == "true") {
            var arrowInner = this.showTabArrow();
            arrow.appendChild(arrowInner);
          } else {
            $(arrow).addClass("boxGradientArrow");
          }

          this.el.appendChild(arrow);
        },

        setTemplatePreset: function() {
          var template;
          switch(this.options.templatePreset) {
            case "default-results": 
              template = DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default;
              break;
            case "gallery-results":
              template = GALLERY_TEMPLATE && GALLERY_TEMPLATE.default;
              break;
            case "person-results":
              template = PERSON_TEMPLATE && PERSON_TEMPLATE.default;
              break;
            default:
              template = DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default;
          }

          this.el.className = "searchboxElement " + this.options.templatePreset;
          if (this.options.templateClass) this.el.className += " " + this.options.templateClass;

          return template;
        },

        showTabArrow: function() {
          var arrowInner = document.createElement('div');
          arrowInner.className = "tabArrowInner";
          arrowInner.setAttribute("data-action-object", '{"changeView":{"name": "' + this.options.name + '", "model": null }}');
          if (this.options.name) arrowInner.setAttribute("title", 'Show all results for "' + i18n(this.options.name) + '"');
          return arrowInner;
        },

        replaceTemplateOptions: function (templateString) {
          var icon = "",
              templateTitle = "",
              title;
          
          if (this.options.templateTitle) {
            templateTitle = i18n(this.options.templateTitle);
          }

          if (this.options.templateIcon) {
            icon = this.options.templateIcon;
            title = icon.concat(templateTitle);
          } else {
            title = templateTitle;
          }
          
          templateString = templateString.replace(/{{templateoptions.title}}/g, title);
          templateString = templateString.replace(/{{templateoptions.actionTitle}}/g, templateTitle);
          
          return templateString;
        },

        updateParentIfUserQueryChanged: function () {
          var unparsedUserQuery = this.model.input.get(this.options.application.getUnparsedUserQueryPath());
          if (this.options.application.getUnparsedUserQuery() !== unparsedUserQuery) {
            this.options.application.setUnparsedUserQuery(unparsedUserQuery);
          }
        },

        updateGlobalSearchIfNeeded: function (model, change) {
          var paths = this.options.propagateInputPathToApplicationSearch.split(/\s+/);
          var keys = _.keys(model.changed);
          var wantedChanges = _.filter(keys, function(key) {
            var anyPath = _.filter(paths, function(path) {
              return key.startsWith(path);
            });
            return !_.isEmpty(anyPath);
          });
          
          if (_.isEmpty(wantedChanges)) {
            return;
          }

          var that = this;
          _.each(wantedChanges, function(changeKey) {
            var v = model.get(changeKey);
            if (!v) {
              that.options.application.models.search.unset(changeKey, {silent:true});
            } else {
              that.options.application.models.search.set(changeKey, v, {silent:true});
            }
          });
          
          that.options.application.models.search.input.change();
        },


      
        createModel: function (options) {
          var models = this.options.application.models;
          this.modelId = this.options.modelId || ("search_" + this.cid);
          this.model = models[this.modelId] = api.search.createModel(options && options.channel || models.channels, { 
            clientExtensions: this.options.application.getClientExtensions(),
            enableImmediateDisplayOfFederatedResults: this.options.application.options.enableImmediateDisplayOfFederatedResults
          });
          
          if (this.options.propagateToParent) {
            this.listenTo(this.model.output, "change", function(model) {
                if (this._enabled) models.search.output.load(this.model.output.attributes, {parse:false, merge:false});
            });
            this.listenTo(this.model.computedInput, "change", function(model) {
                if (this._enabled) models.search.computedInput.load(this.model.computedInput.attributes, {parse:false, merge:false});
            });
            this.listenTo(this.model, "computing", function () { models.search.trigger("computing") });
            this.listenTo(this.model, "computed", function () { models.search.trigger("computed") });
          }
        },

        getAsBoolean: function(prop) {
          return prop === 'true' || prop === true;
        },
        resetModel: function (name) {
          var retainedUserQuery;
          if (this.getAsBoolean(this.options.parentUserQueryAsConstraint)) {
            retainedUserQuery = deepClone(this.model.input.get("user.query"));
          }
          this.model.input.clear({silent: true});
          this.model.input.set(this.originalInput, {silent: true});
         
          if (this.getAsBoolean(this.options.parentUserQueryAsConstraint)) {
            this.model.input.set("user.query", retainedUserQuery, { silent: true });
          }
          this.setSearchName();
        },

        setSearchName: function () {
          var searchName = _.uniqueId("app");

          if (this.options.name) {
            searchName = this.options.name;
          } else if (this.options.constraint) {
            searchName = this.options.constraint.unparsed
          }
          this.model.set("name", searchName, {silent:true});
        },

        disable: function () {
          this._enabled = false;

          $(this.options.application.rootEls).attr("data-enabled-searchcontainers", ($(this.options.application.rootEls).attr("data-enabled-searchcontainers") || "").replace(this.options.templateRefid, ""));
          this.$el.hide();
          this.model.deactivate();
          this.model.output.load({});
        },

        enable: function () {
          if (this._enabled) return;
          this._enabled = true;
          $(this.options.application.rootEls).attr("data-enabled-searchcontainers", ($(this.options.application.rootEls).attr("data-enabled-searchcontainers") || "").replace(this.options.templateRefid, "") + " " + this.options.templateRefid);
          this.updateDisplay();
          this.model.output.load({});
          this.model.activate();
        },

        updateInput: function () {
          var viewName = this.options.application.models.search.input.get("source_context.constraints.view.name") || "Everything",
              viewDescription = this.options.application.models.search.input.get("source_context.constraints.view.description"),
              inEnabled = _.indexOf(this.options.enabledViews, viewName) >= 0,
              inDisabled = _.indexOf(this.options.disabledViews, viewName) >= 0,
              enabled = !(this.options.enabledViews && !inEnabled || inDisabled);

          if (!enabled) {
            this.disable();
          }

          if (enabled) {
            if (this.parentApplication) return;
            this.resetModel(viewDescription);
            var input = this.options.application.models.search.input.get();

            this.model.input.set(this.transformInput(input, this.options.application.models.search.input));
        // this.model.output.load({__manual_reset__: true}, {parse:false, merge:false});
            this.enable();
          }
        },

        updateDisplay: function () {
          if (!this._enabled) return;
          if (this.options.hideOnNoResults) {
            // TODO: resultCollection
            var results = this.resultsModel.get();
            if (results && results.length) {
              this.$el.show();
            } else {
              this.$el.hide();
            }
          } else {
            this.$el.show();
          }
        },

        mergeUserConstraints: function (parent, child) {
          // prefer inherit filters from the parent search
          return Object.assign(child || {}, parent || {});
        },

        transformInput: function (input, model) {
          // TODO: how do we handle that correctly for tabs and without tabs?
          if (this.options.constraint) {
            input.source_context = input.source_context || {};
            input.source_context.constraints = input.source_context.constraints || {};
            input.source_context.constraints.search = this.options.constraint;
          }

          if (this.options.count != null) {
            input.count = this.options.count;
          }
          
          if (this.options.name) {
            input.name = this.options.name;
          }

          if (this.options.inputTransform) {
            this.options.inputTransform.call(window, input,this.options.application);
          } else {
            
            var parentUserQuery = input.user && input.user.query || null;
            var userQuery = deepClone(parentUserQuery);
            if (this.getAsBoolean(this.options.parentUserQueryAsConstraint)) {
              var retainedUserQuery = deepClone(this.model.input.get("user.query"));
              
              if (retainedUserQuery || !this.getAsBoolean(this.options.initializeFromParentUserQuery)) {
                userQuery = retainedUserQuery;
              }
            }
            
            // should use same user constraints from parent search
            var inheritConstraintsFromParent = this.options.inheritConstraintsFromParent || !_.isEmpty(this.options.inheritInputPathFromParent);
            var searchcontainerConstraints = this.model.get("user.constraints") || {};
            
            if (inheritConstraintsFromParent && input.user && input.user.constraints) {
              var inputConstraints = input.user.constraints || {};
              
              if (this.options.inheritInputPathFromParent) {
                // e.g. user.constriant.filterA
                var paths = this.options.inheritInputPathFromParent.split(/\s+/);
                paths = _.filter(paths, function(path) {
                  return path.startsWith("user.constraints.");
                });
                var pathSuffixes = _.map(paths, function(path) { return path.substring("user.constraints.".length).split(".")[0]; });
                inputConstraints = _.reduce(pathSuffixes, function(attr, key) {
                  if (inputConstraints[key]) {
                    attr[key] = inputConstraints[key];
                  }
                  return attr;
                }, {});
              }
              var unset = []
              if (model) {
                unset = _.filter(_.keys(model.changed), function(key) { return !model.changed[key] });
                unset = _.map(unset, function(key) { return key.substring("user.constraints.".length).split(".")[0] });
              }
              searchcontainerConstraints = this.mergeUserConstraints(inputConstraints, searchcontainerConstraints);
              _.each(unset, function(key) {
                delete searchcontainerConstraints[key];
              });
            }
            if(input.user && _.isEmpty(input.user.constraints)){
              searchcontainerConstraints = {};
            }

            if (this.getAsBoolean(this.options.parentUserQueryAsConstraint)) {
              searchcontainerConstraints = searchcontainerConstraints || {};
              searchcontainerConstraints["searchcontainer_user_query_" + this.modelId] = _.extend({expandable: true}, parentUserQuery);
            }

            if (!userQuery) {

              var user = {user: {}};

              if (searchcontainerConstraints) {
                user.user.constraints = searchcontainerConstraints;
              }

              return user;
            }

            var user = {user: { query: userQuery } };

            if (searchcontainerConstraints) {
              user.user.constraints = searchcontainerConstraints;
            }

            return user;
          }
          return input;
        },

        setEditable: function (editable) {
        },

    });

    return SearchTemplate;
  }
);
